import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    answers: {},
    username: "shuja",
    myList1: [
      { text: "John", id: 1 },
      { text: "Joao", id: 2 },
      { text: "Jean", id: 3 },
      { text: "Gerard", id: 4 },
    ],
    myList2: [
      { text: "Juan", id: 5 },
      { text: "Edgard", id: 6 },
      { text: "Johnson", id: 7 },
    ],
  },
  getters: {
    getAnswers: function (state) {
      return state.answers;
    },
  },
  mutations: {
    updateAnswer: function (state, payload) {
      state.answers[payload.key] = payload.value;
      //console.log(state.answers)
    },
    updateList1: function (state, payload) {
      state.myList1 = payload;
    },
    updateList2: function (state, payload) {
      state.myList2 = payload;
    },
    updateOrderAnswers: (state, payload) => {
      state.answers[payload.key] = payload.value;
      //state.myList1 = payload;
    }
  },
  modules: {},
  actions: {
    updateOrderAnswers: ({ commit }, payload) => {
      commit("updateOrderAnswers", payload);
    }
  }
});
